import React, {useEffect, useState} from "react";
import styles from "../../styles/create_styles.module.scss";
import {ReactComponent as Arrow} from "../../assets/icons/arrow-left.svg";

import Select from "react-select";
import Switch from 'react-switch';

import {useParams} from "react-router-dom";
import {useMutation, useQuery} from "react-query";
import {filterTeams, getProduct, storeProduct, filterCategories} from "../../services/services";
import {toast} from "react-toastify";
import {Form, Formik} from "formik";
import {BarLoader} from "react-spinners";
import Button from "../../components/Button/Button";
import {ReactComponent as Upload} from "../../assets/icons/upload.svg";
import {IGetProduct, IPostProduct, IProductImage, IProductSize} from "../../ts/interfaces/Product/interface";
import {IFilter} from "../../ts/interfaces/interface";
import {queryClient} from "../../services/queryClient";


const CreateProduct: React.FC = () => {
    const queryParams = useParams();

    document.title = 'Admin - ' + (queryParams?.id ? 'Editar' : 'Cadastrar') + ' produto';

    const [images, setImages] = useState<IProductImage[]>([]);
    const [sizes, setSizes] = useState<IProductSize[]>([]);

    const labelSizes = [
        {value: "PP", label: "PP"},
        {value: "P", label: "P"},
        {value: "M", label: "M"},
        {value: "G", label: "G"},
        {value: "GG", label: "GG"},
    ];

    const [sizeImage, setSizeImage] = useState<string | null>(null);
    const [fileNames, setFileNames] = useState<string[]>([]);

    const stylesSelect = {
        control: (styles: any) => ({
            ...styles,
            width: "100%",
            height: "37px",
        }),
        indicatorsContainer: (styles: any) => ({
            ...styles,
            height: "37px",
        }),
        valueContainer: (styles: any) => ({
            ...styles,
            height: "37px",
            display: "flex",
            alignItems: "center",
            padding: "0px 8px",
            "overflow-y": "auto"
        }),
        dropdownIndicator: (styles: any) => ({
            ...styles,
            padding: "4px",
        }),
        clearIndicator: (styles: any) => ({
            ...styles,
            padding: "4px",
        }),
    };

    const {data, isLoading} = useQuery<{
        data: IGetProduct;
        status: number
    }>(
        ["product", queryParams?.id],
        () => getProduct(parseInt(queryParams?.id ?? "0")),
        {

            staleTime: Infinity,
            enabled: !!queryParams?.id,
        }
    );

    if (!isLoading && queryParams?.id && data?.status !== 200) {
        window.location.href = '/products';
    }


    const {data: teams} = useQuery<{ data: IFilter[] }>(
        "filter-teams",
        () => filterTeams()
    );

    const {data: categories} = useQuery<{ data: IFilter[] }>(
        "filter-categories",
        () => filterCategories()
    );

    const [params, setParams] = useState<IPostProduct>({
        id: null,
        name: "",
        sku: "",
        url: "",
        description: "",
        cost: null,
        price: null,
        special_price: null,
        type: "",
        is_active: false,
        team_id: null,
        category_ids: [],
        sizes_image: null,
        gender: "",
        season: null,
    });

    useEffect(() => {
        if (data && data.data) {
            setParams({
                ...params,
                id: data.data.id,
                name: data.data.name,
                sku: data.data.sku,
                url: data.data.url,
                description: data.data.description,
                cost: formatMoney(data.data.cost.toString()),
                price: formatMoney(data.data.price.toString()),
                special_price: data.data.special_price ? formatMoney(data.data.special_price.toString()) : null,
                type: data.data.type,
                is_active: data.data.is_active,
                team_id: data.data.team_id,
                category_ids: data.data.category_ids,
                sizes_image: data.data.sizes_image,
                gender: data.data.gender,
                season: data.data.season
            });

            setImages(data.data.images)
            setSizes(data.data.sizes)
        }
    }, [data]);

    useEffect(() => {
        let url = ''
        if (params.type && params.name.trim() !== '' && !params.id) {
            url = '/' + (params.type === 'shirt' ? 'camisa' : 'short') + '/' + params.name.normalize("NFD")
                .replace('/', "-")
                .replace(/[\u0300-\u036f]/g, "")
                .replace(/[^a-zA-Z0-9\s-]/g, "")
                .trim()
                .replace(/\s+/g, "-")
                .replace(/-+/g, "-")
                .toLowerCase()

                setParams({
                    ...params,
                    url: url
                })
        }

    }, [params.type, params.name]);

    useEffect(() => {
        setParams({
            ...params,
            sku: params.sku.toUpperCase()
        })
    }, [params.sku]);

    useEffect(() => {
        queryClient.invalidateQueries(["product", queryParams?.id])
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        let value = e.target.value
        let floatValues = ['cost', 'price', 'special_price']
        if (floatValues.includes(e.target.name) && value) {
            value = formatMoney(value)
        }

        setParams({...params, [e.target.name]: value});
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, index: number | null = null) => {
        const file = e.target.files?.[0];
        if (file) {
            if (index !== null) {
                let image = images[index];
                if (image) {
                    let copy = images.slice()
                    image = {...image, [e.target.name]: file}
                    copy[index] = image
                    setImages(copy)

                    let fileNamesCopy = fileNames.slice()
                    fileNamesCopy[index] = file.name;
                    setFileNames(fileNamesCopy)
                }

            } else {

                setParams((prevParams) => ({
                    ...prevParams,
                    [e.target.name]: file,
                }));
                setSizeImage(file.name)
            }

        }
    };

    const onSubmit = () => {
        if (!params.name || params.name.trim() === "") {
            toast.error("Preencha o nome.");
            return;
        }

        if (!params.sku || params.sku.trim() === "") {
            toast.error("Preencha o SKU.");
            return;
        }

        if (!params.type) {
            toast.error("Selecione o tipo.");
            return;
        }

        if (!params.gender) {
            toast.error("Selecione um gênero.");
            return;
        }

        if (!params.cost) {
            toast.error("Preencha o custo.");
            return;
        }

        let cost = parseMoneyToFloat(params.cost ?? "")
        if (cost <= 0) {
            toast.error("Preencha o custo corretamente.");
            return;
        }

        if (!params.price) {
            toast.error("Preencha o preço.");
            return;
        }

        let price = parseMoneyToFloat(params.price ?? "")
        if (price <= 0) {
            toast.error("Preencha o preço corretamente.");
            return;
        }

        let specialPrice = parseMoneyToFloat(params.special_price ?? "")

        const formData = new FormData();

        formData.append("id", params.id ? params.id.toString() : "");
        formData.append("name", params.name ?? "");
        formData.append("sku", params.sku ?? "");
        formData.append("url", params.url ?? "");
        formData.append("description", params.description ?? "");
        formData.append("cost", cost.toString());
        formData.append("price", price.toString());
        formData.append("special_price", specialPrice > 0 ? specialPrice.toString() : "");
        formData.append("type", params.type ?? "");
        formData.append("is_active", params.is_active ? '1' : '0');
        formData.append("team_id", params.team_id ? params.team_id.toString() : "");
        formData.append("category_ids", params.category_ids ? params.category_ids.join(',') : "");
        formData.append("gender", params.gender ?? "");
        formData.append("season", params.season ?? "");

        if (params.sizes_image instanceof File) {
            formData.append("sizes_image", params.sizes_image);
        }

        for (let i = 0; i < images.length; i++) {
            const {id, url, order} = images[i]
            if (!url || !order) {
                toast.error("Preencha todas as informações das imagens.")
                return;
            }

            let position = i + 1;
            formData.append(`image_id_${position}`, id?.toString() ?? '');
            formData.append(`image_order_${position}`, order.toString());
            if (url instanceof File) {
                formData.append(`image_file_${position}`, url);
            }
        }

        for (let i = 0; i < sizes.length; i++) {
            const {id, name, stock} = sizes[i]
            if (!name) {
                toast.error("Preencha todas as informações dos tamanhos.")
                return;
            }

            let position = i + 1;
            formData.append(`size_id_${position}`, id?.toString() ?? '');
            formData.append(`size_name_${position}`, name);
            formData.append(`size_stock_${position}`, stock.toString());
        }

        mutate.mutate(formData);
    };

    const mutate = useMutation(
        (data: FormData) => {
            return storeProduct(data);
        },
        {
            onSettled: (response) => {
                if (response?.data?.product_id) {
                    toast.success("Salvo com sucesso!");

                    setTimeout(() => {
                        window.location.href = "/product/create/" + response.data.product_id;
                    }, 800);
                } else {
                    toast.error("Erro ao salvar o produto. " + (response?.data?.msg ?? ''));
                }
            },
            onError: (error) => {
                toast.error("Erro ao salvar o produto");
            },
        }
    );

    const formatMoney = (value: string) => {
        const numericValue = parseFloat(value.replace(/[^\d]/g, "") || '0') / 100;
        return numericValue.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });
    };

    const parseMoneyToFloat = (formattedValue: string): number => {
        const numericValue = formattedValue
            .replace(/[^0-9,.-]+/g, "")
            .replace('.', "")
            .replace(',', '.');

        return parseFloat(numericValue) || 0;
    };

    const addImage = (index: number) => {
        let image: IProductImage = {
            id: null,
            order: index + 1,
            url: null,
        };

        let copy = images.slice()
        copy.push(image)
        setImages(copy)
    }

    const removeImage = (index: number) => {
        let copy = images.slice()
        let image = copy[index]

        if (image) {
            copy.splice(index, 1)
            setImages(copy)
        }
    }


    const addSize = () => {
        let size: IProductSize = {
            id: null,
            name: "",
            stock: 0,
        };

        let copy = sizes.slice()
        copy.push(size)
        setSizes(copy)
    }

    const removeSize = (index: number) => {
        let copy = sizes.slice()
        let size = copy[index]

        if (size) {
            copy.splice(index, 1)
            setSizes(copy)
        }
    }

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>, index: number) => {
        let copy = images.slice()
        let image = copy[index]

        if (image) {
            let lastOrder = image.order
            image.order = parseInt(e.target.value)

            const reorderedImages = copy
                .filter((_, i) => i !== index)
                .map((item) => {
                    if (item.order > image.order || (item.order === image.order && lastOrder > image.order)) {
                        item.order = item.order + 1
                    }

                    if (item.order < image.order || (item.order === image.order && lastOrder < image.order)) {
                        item.order = item.order - 1
                    }

                    return item
                })
                .concat(image)
                .sort((a, b) => a.order - b.order)
                .map((img, idx) => ({...img, order: idx + 1}));

            setImages(reorderedImages);
        }
    };

    const handleSizeChange = (name: string, value: any, index: number) => {
        let copy = sizes.slice()
        let size = copy[index]

        if (size) {
            size = {...size, [name]: value}
            copy[index] = size
            setSizes(copy)
        }
    };

    const getSizes = () => {
        let used = sizes.map(size => size.name)

        return labelSizes.filter(item => !used.includes(item.value))
    }

    const getSeasons = () => {
        let year = new Date().getFullYear();
        let seasons = [];

        for (let i = year; i >= 2010; i--) {
            let value = i.toString().slice(2)
            let nextYear = (i + 1).toString().slice(2)

            seasons.push({
                value: value + '/' + nextYear,
                label: value + '/' + nextYear
            })
        }

        return seasons;
    }

    return (
        <>
            <Formik
                initialValues={{
                    name: "",
                    sku: "",
                    url: "",
                }}
                onSubmit={() => onSubmit()}
            >
                <Form className={styles.container}>
                    <div className={styles.content}>
                        <div className={styles.title}>
                            <a
                                href="/products"
                                className={styles.btnReturn}
                            >
                                <Arrow/> Voltar
                            </a>
                            <h1>
                                {params.id ? "Editar" : "Cadastrar"} Produto
                            </h1>
                        </div>
                        {isLoading ? (
                            <div className={styles.alignCenter}>
                                <span>Carregando</span>
                                <BarLoader
                                    color={"#ff7526"}
                                    loading={isLoading}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />
                            </div>
                        ) : (
                            <>
                                <div className={styles.box}>
                                    <div className={styles.switch}>
                                        <p className={styles.boxTitle}>
                                            Informe os dados do produto {queryParams?.id}
                                        </p>
                                        <div>
                                            <span>Ativo</span>
                                            <Switch
                                                onChange={() => setParams({...params, is_active: !params.is_active})}
                                                checked={params.is_active}
                                                offColor="#888"
                                                onColor="#ff7526"
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                height={20}
                                                width={40}
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.groupData}>
                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="name">
                                                    Nome
                                                </label>
                                                <input
                                                    disabled={mutate.isLoading}
                                                    value={params.name}
                                                    onChange={(e) =>
                                                        handleChange(e)
                                                    }
                                                    className={styles.input}
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="sku">
                                                    SKU
                                                </label>
                                                <input
                                                    disabled={mutate.isLoading}
                                                    value={params.sku}
                                                    onChange={(e) =>
                                                        handleChange(e)
                                                    }
                                                    className={styles.input}
                                                    type="text"
                                                    name="sku"
                                                    id="sku"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="team_id">
                                                    Time
                                                </label>
                                                <Select
                                                    defaultValue={{
                                                        value: data?.data.team_id,
                                                        label: data?.data.team_name ?? "",
                                                    }}
                                                    name="team_id"
                                                    styles={stylesSelect}
                                                    options={teams?.data ?? []}
                                                    onChange={(
                                                        selectedOption
                                                    ) => {
                                                        setParams({
                                                            ...params,
                                                            team_id:
                                                                selectedOption?.value ??
                                                                null,
                                                        });
                                                    }}
                                                    placeholder="Selecione o time..."
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="url">
                                                    Url
                                                </label>
                                                <input
                                                    disabled={true}
                                                    value={params.url}
                                                    onChange={(e) =>
                                                        handleChange(e)
                                                    }
                                                    className={styles.input}
                                                    type="text"
                                                    name="url"
                                                    id="url"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="type">
                                                    Tipo
                                                </label>
                                                <Select
                                                    defaultValue={{
                                                        value: data?.data.type,
                                                        label: data?.data.type_name,
                                                    }}
                                                    name="type"
                                                    styles={stylesSelect}
                                                    options={[
                                                        {value: "shirt", label: "Camisa"},
                                                        {value: "shorts", label: "Short"},
                                                    ]}
                                                    onChange={(
                                                        selectedOption
                                                    ) => {
                                                        setParams({
                                                            ...params,
                                                            type:
                                                                selectedOption?.value ??
                                                                "",
                                                        });
                                                    }}
                                                    placeholder="Selecione o tipo..."
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="season">
                                                    Temporada
                                                </label>
                                                <Select
                                                    defaultValue={{
                                                        value: data?.data.season,
                                                        label: data?.data.season,
                                                    }}
                                                    name="season"
                                                    styles={stylesSelect}
                                                    options={getSeasons()}
                                                    onChange={(
                                                        selectedOption
                                                    ) => {
                                                        setParams({
                                                            ...params,
                                                            season:
                                                                selectedOption?.value ??
                                                                "",
                                                        });
                                                    }}
                                                    placeholder="Selecione a temporada..."
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="gender">
                                                    Gênero
                                                </label>
                                                <Select
                                                    defaultValue={{
                                                        value: data?.data.gender,
                                                        label: data?.data.gender_name,
                                                    }}
                                                    name="gender"
                                                    styles={stylesSelect}
                                                    options={[
                                                        {value: "masculine", label: "Masculino"},
                                                        {value: "feminine", label: "Feminino"},
                                                        {value: "unisex", label: "Unisex"},
                                                        {value: "kids", label: "Infantil"},
                                                    ]}
                                                    onChange={(
                                                        selectedOption
                                                    ) => {
                                                        setParams({
                                                            ...params,
                                                            gender:
                                                                selectedOption?.value ??
                                                                "",
                                                        });
                                                    }}
                                                    placeholder="Selecione o gênero..."
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="category_ids">
                                                    Categorias
                                                </label>
                                                <Select
                                                    defaultValue={data?.data?.categories ?? []}
                                                    name="category_ids"
                                                    styles={stylesSelect}
                                                    options={categories?.data ?? []}
                                                    onChange={(
                                                        selectedOption
                                                    ) => {
                                                        setParams({
                                                            ...params,
                                                            category_ids: selectedOption.map(item => item.value)
                                                        });
                                                    }}
                                                    isMulti
                                                    placeholder="Selecione as categorias..."
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="url_icon">
                                                    Dimensões
                                                </label>
                                                <div
                                                    className={styles.fileInput}
                                                >
                                                    <input
                                                        disabled={
                                                            mutate.isLoading
                                                        }
                                                        onChange={(e) => {
                                                            handleFileChange(e);
                                                        }}
                                                        className={styles.input}
                                                        type="file"
                                                        name="sizes_image"
                                                        id="sizes_image"
                                                    />
                                                    {sizeImage ? (
                                                        <span>
                                                            {" "}
                                                            <Upload/>{" "}
                                                            <p>{sizeImage}</p>
                                                        </span>
                                                    ) : (
                                                        <span>
                                                            <Upload/> <p>Faça o
                                                            upload da imagem de dimensões</p>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            {typeof params.sizes_image ===
                                                "string" && (
                                                    <div
                                                        className={
                                                            styles.urlNoticeContainer
                                                        }
                                                    >
                                                        Arquivo:{" "}
                                                        <a
                                                            href={params.sizes_image}
                                                            className={
                                                                styles.urlNotice
                                                            }
                                                            target="_blank"
                                                        >
                                                            {params.sizes_image}
                                                        </a>
                                                    </div>
                                                )}
                                        </div>

                                        {/*<div>*/}
                                        {/*    <div className={styles.groupInput}>*/}
                                        {/*        <label htmlFor="institution_id">*/}
                                        {/*            Instituição*/}
                                        {/*        </label>*/}
                                        {/*        <Select*/}
                                        {/*            defaultValue={{*/}
                                        {/*                value: data?.data*/}
                                        {/*                    .institution_id,*/}
                                        {/*                label: institutions?.data.institutions.find(*/}
                                        {/*                    (institution) =>*/}
                                        {/*                        institution.id ===*/}
                                        {/*                        data?.data*/}
                                        {/*                            .institution_id*/}
                                        {/*                )?.name,*/}
                                        {/*            }}*/}
                                        {/*            name="institution_id"*/}
                                        {/*            styles={stylesSelect}*/}
                                        {/*            options={institutions?.data.institutions.map(*/}
                                        {/*                (institution) => ({*/}
                                        {/*                    value: institution.id,*/}
                                        {/*                    label: institution.name,*/}
                                        {/*                })*/}
                                        {/*            )}*/}
                                        {/*            onChange={(*/}
                                        {/*                selectedOption*/}
                                        {/*            ) => {*/}
                                        {/*                setParams({*/}
                                        {/*                    ...params,*/}
                                        {/*                    institution_id:*/}
                                        {/*                        selectedOption?.value ??*/}
                                        {/*                        0,*/}
                                        {/*                });*/}
                                        {/*            }}*/}
                                        {/*            placeholder="Selecione a instituição..."*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}


                                        {/*<div>*/}
                                        {/*    <div className={styles.groupInput}>*/}
                                        {/*        <label htmlFor="url_notice">*/}
                                        {/*            Edital*/}
                                        {/*        </label>*/}
                                        {/*        <div*/}
                                        {/*            className={styles.fileInput}*/}
                                        {/*        >*/}
                                        {/*            <input*/}
                                        {/*                disabled={*/}
                                        {/*                    mutate.isLoading*/}
                                        {/*                }*/}
                                        {/*                onChange={(e) => {*/}
                                        {/*                    handleFileChange(e, "url_notice");*/}
                                        {/*                }}*/}
                                        {/*                className={styles.input}*/}
                                        {/*                type="file"*/}
                                        {/*                name="url_notice"*/}
                                        {/*                id="url_notice"*/}
                                        {/*            />*/}
                                        {/*            {fileName.url_notice ? (*/}
                                        {/*                <span>*/}
                                        {/*                    {" "}*/}
                                        {/*                    <Upload/>{" "}*/}
                                        {/*                    <p>{fileName.url_notice}</p>*/}
                                        {/*                </span>*/}
                                        {/*            ) : (*/}
                                        {/*                <span>*/}
                                        {/*                    <Upload/> <p>Faça o*/}
                                        {/*                    upload do edital</p>*/}
                                        {/*                </span>*/}
                                        {/*            )}*/}
                                        {/*        </div>*/}
                                        {/*    </div>*/}
                                        {/*    {typeof params.url_notice ===*/}
                                        {/*        "string" && (*/}
                                        {/*            <div*/}
                                        {/*                className={*/}
                                        {/*                    styles.urlNoticeContainer*/}
                                        {/*                }*/}
                                        {/*            >*/}
                                        {/*                Arquivo:{" "}*/}
                                        {/*                <a*/}
                                        {/*                    href={params.url_notice}*/}
                                        {/*                    className={*/}
                                        {/*                        styles.urlNotice*/}
                                        {/*                    }*/}
                                        {/*                >*/}
                                        {/*                    {params.url_notice}*/}
                                        {/*                </a>*/}
                                        {/*            </div>*/}
                                        {/*        )}*/}
                                        {/*</div>*/}

                                        {/*<div>*/}
                                        {/*    <div className={styles.groupInput}>*/}
                                        {/*        <label htmlFor="test_date">*/}
                                        {/*            Data da prova*/}
                                        {/*        </label>*/}
                                        {/*        <input*/}
                                        {/*            disabled={mutate.isLoading}*/}
                                        {/*            className={styles.input}*/}
                                        {/*            value={params.test_date}*/}
                                        {/*            onChange={(e) =>*/}
                                        {/*                handleChange(e)*/}
                                        {/*            }*/}
                                        {/*            type="date"*/}
                                        {/*            name="test_date"*/}
                                        {/*            id="test_date"*/}
                                        {/*        />*/}
                                        {/*    </div>*/}
                                        {/*</div>*/}

                                        {/*<div className={styles.groupInput}>*/}
                                        {/*    <label htmlFor="">Estados</label>*/}
                                        {/*    <Select*/}
                                        {/*        defaultValue={data?.data.states.map(*/}
                                        {/*            (state) => ({*/}
                                        {/*                value: state.id,*/}
                                        {/*                label: state.name,*/}
                                        {/*            })*/}
                                        {/*        )}*/}
                                        {/*        styles={stylesSelect}*/}
                                        {/*        options={states?.data.states.map(*/}
                                        {/*            (state) => ({*/}
                                        {/*                value: state.id,*/}
                                        {/*                label: state.name,*/}
                                        {/*            })*/}
                                        {/*        )}*/}
                                        {/*        placeholder="Selecione os estados..."*/}
                                        {/*        onChange={(selectedOptions) => {*/}
                                        {/*            setParams({*/}
                                        {/*                ...params,*/}
                                        {/*                states: selectedOptions.map(*/}
                                        {/*                    (option) =>*/}
                                        {/*                        option.value*/}
                                        {/*                ),*/}
                                        {/*            });*/}
                                        {/*        }}*/}
                                        {/*        isMulti*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                        {/*<div className={styles.groupInput}>*/}
                                        {/*    <label htmlFor="">Cargos</label>*/}
                                        {/*    <Select*/}
                                        {/*        defaultValue={data?.data.occupations.map(*/}
                                        {/*            (occupation) => ({*/}
                                        {/*                value: occupation.id,*/}
                                        {/*                label: occupation.name,*/}
                                        {/*            })*/}
                                        {/*        )}*/}
                                        {/*        styles={stylesSelect}*/}
                                        {/*        options={occupations?.data.occupations.map(*/}
                                        {/*            (occupation) => ({*/}
                                        {/*                value: occupation.id,*/}
                                        {/*                label: occupation.name,*/}
                                        {/*            })*/}
                                        {/*        )}*/}
                                        {/*        onChange={handleOccupationsChange}*/}
                                        {/*        placeholder="Selecione os cargos..."*/}
                                        {/*        isMulti*/}
                                        {/*    />*/}
                                        {/*</div>*/}
                                    </div>
                                </div>

                                <div className={styles.box}>
                                    <p className={styles.boxTitle}>
                                        Precificação
                                    </p>
                                    <div className={styles.groupData}>
                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="cost">
                                                    Custo
                                                </label>
                                                <input
                                                    disabled={mutate.isLoading}
                                                    value={params.cost ?? ""}
                                                    onChange={(e) =>
                                                        handleChange(e)
                                                    }
                                                    className={styles.input}
                                                    type="text"
                                                    name="cost"
                                                    id="cost"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="price">
                                                    Preço
                                                </label>
                                                <input
                                                    disabled={mutate.isLoading}
                                                    value={params.price ?? ""}
                                                    onChange={(e) =>
                                                        handleChange(e)
                                                    }
                                                    className={styles.input}
                                                    type="text"
                                                    name="price"
                                                    id="price"
                                                />
                                            </div>
                                        </div>

                                        <div>
                                            <div className={styles.groupInput}>
                                                <label htmlFor="special_price">
                                                    Preço Promocional
                                                </label>
                                                <input
                                                    disabled={mutate.isLoading}
                                                    value={params.special_price ?? ""}
                                                    onChange={(e) =>
                                                        handleChange(e)
                                                    }
                                                    className={styles.input}
                                                    type="text"
                                                    name="special_price"
                                                    id="special_price"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.alignTextArea}>
                                    <label htmlFor="description">
                                        Descrição
                                    </label>

                                    <textarea
                                        disabled={mutate.isLoading}
                                        value={params.description ?? ""}
                                        onChange={(e) =>
                                            handleChange(e)
                                        }
                                        className={styles.input}
                                        name="description"
                                        id="description"
                                    />
                                </div>

                                <div className={styles.box}>
                                    <Button
                                        width="115px"
                                        height="39px"
                                        theme="primary"
                                        fontSize="14px"
                                        onClick={() => addImage(images.length)}
                                        disabled={isLoading || images.length >= 5}
                                        type="button"
                                    >
                                        + Imagem
                                    </Button>

                                    {images.length > 0 &&
                                        <div className={styles.box}>
                                            <div className={styles.groupData}>
                                                {images.sort((a, b) => a.order - b.order).map((image, index) => {
                                                    return (
                                                        <div key={index} className={styles.cardImage}>
                                                            <div className={styles.close}>
                                                                    <span
                                                                        onClick={() => removeImage(index)}>&times;</span>
                                                            </div>
                                                            {typeof image.url === "string" &&
                                                                <div className={styles.image}><img src={image.url}
                                                                                                   alt={`Produto Imagem ${index + 1}`}/>
                                                                </div>}
                                                            <div className={styles.groupInput}>
                                                                <label>
                                                                    Arquivo
                                                                </label>
                                                                <div
                                                                    className={styles.fileInput}
                                                                >
                                                                    <input
                                                                        disabled={
                                                                            mutate.isLoading
                                                                        }
                                                                        onChange={(e) => {
                                                                            handleFileChange(e, index);
                                                                        }}
                                                                        className={styles.input}
                                                                        type="file"
                                                                        name="url"
                                                                        id="url"
                                                                    />
                                                                    {fileNames[index] ? (
                                                                        <span>{" "}<Upload/>{" "}
                                                                            <p>{fileNames[index]}</p>
                                                                            </span>
                                                                    ) : (
                                                                        <span><Upload/> <p>Faça o upload da imagem do produto</p></span>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {typeof image.url ===
                                                                "string" && (
                                                                    <div
                                                                        className={
                                                                            styles.urlNoticeContainer
                                                                        }
                                                                    >
                                                                        Arquivo:{" "}
                                                                        <a
                                                                            href={image.url}
                                                                            className={
                                                                                styles.urlNotice
                                                                            }
                                                                            target="_blank"
                                                                        >
                                                                            {image.url}
                                                                        </a>
                                                                    </div>
                                                                )}

                                                            <div className={styles.groupInput}>
                                                                <label>
                                                                    Posição
                                                                </label>
                                                                <input
                                                                    disabled={mutate.isLoading}
                                                                    value={image.order}
                                                                    onChange={(e) =>
                                                                        handleImageChange(e, index)
                                                                    }
                                                                    className={styles.input}
                                                                    type="number"
                                                                    name="order"
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className={styles.box}>
                                    <Button
                                        width="115px"
                                        height="39px"
                                        theme="primary"
                                        fontSize="14px"
                                        onClick={() => addSize()}
                                        disabled={isLoading || sizes.length === labelSizes.length}
                                        type="button"
                                    >
                                        + Tamanho
                                    </Button>

                                    {sizes.length > 0 &&
                                        <div className={styles.box}>
                                            <div className={styles.groupData}>
                                                {sizes.map((size, index) => {
                                                    return (
                                                        <div key={index} className={styles.cardImage}>
                                                            <div className={styles.close}>
                                                                    <span
                                                                        onClick={() => removeSize(index)}>&times;</span>
                                                            </div>
                                                            <div className={styles.groupInput}>
                                                                <label>
                                                                    Tamanho
                                                                </label>
                                                                <Select
                                                                    name="name"
                                                                    styles={stylesSelect}
                                                                    value={{
                                                                        value: size.name,
                                                                        label: size.name,
                                                                    }}
                                                                    options={getSizes()}
                                                                    onChange={(
                                                                        selectedOption
                                                                    ) => handleSizeChange('name', selectedOption?.value ?? "", index)}
                                                                    placeholder="Selecione o tamanho..."
                                                                />
                                                            </div>
                                                            <div className={styles.groupInput}>
                                                                <label>
                                                                    Estoque
                                                                </label>
                                                                <input
                                                                    disabled={mutate.isLoading}
                                                                    value={size.stock}
                                                                    onChange={(e) =>
                                                                        handleSizeChange(e.target.name, e.target.value, index)
                                                                    }
                                                                    className={styles.input}
                                                                    type="number"
                                                                    name="stock"
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className={styles.box}>
                                    <div className={styles.alignButtons}>
                                        <Button
                                            disabled={mutate.isLoading}
                                            width="175px"
                                            height="50px"
                                            type="submit"
                                        >
                                            Salvar
                                        </Button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </Form>
            </Formik>
        </>
    );
};

export default CreateProduct;
